module.exports = __webpack_public_path__ + "img/MatschCheck.cc783290.jpg";